import { render } from "./CreateLeadModal.vue?vue&type=template&id=150815f9&scoped=true"
import script from "./CreateLeadModal.vue?vue&type=script&lang=js"
export * from "./CreateLeadModal.vue?vue&type=script&lang=js"

import "./CreateLeadModal.vue?vue&type=style&index=0&id=150815f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150815f9"]])

export default __exports__